import { render, staticRenderFns } from "./CriterionListGroup.vue?vue&type=template&id=b118f964&"
import script from "./CriterionListGroup.vue?vue&type=script&lang=js&"
export * from "./CriterionListGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b118f964')) {
      api.createRecord('b118f964', component.options)
    } else {
      api.reload('b118f964', component.options)
    }
    module.hot.accept("./CriterionListGroup.vue?vue&type=template&id=b118f964&", function () {
      api.rerender('b118f964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/criterion/group/CriterionListGroup.vue"
export default component.exports